export default __webpack_public_path__ + "static/media/yellow-btn.8c22052a.png";